"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Account = function Account(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "account",
    viewBox: "0 0 26 26"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-1282.000000, -28.000000)",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    d: "M1294.07933,29.1120725 C1298.9837,28.7338342 1303.62235,31.3865495 1305.78345,35.8053247 C1307.94454,40.2240999 1307.1905,45.5142276 1303.88087,49.153217 C1303.46408,49.6100649 1303.013,50.0343989 1302.53156,50.4225136 C1300.40315,52.1493708 1297.74298,53.0869233 1295.00218,53.0762684 C1292.26102,53.0746508 1289.60255,52.1372595 1287.46668,50.4191241 C1283.6382,47.3306447 1282.08192,42.2186955 1283.53991,37.5208065 C1284.99791,32.8229176 1289.17496,29.4903108 1294.07933,29.1120725 Z M1295.00218,30.6573249 C1291.01838,30.6563122 1287.38364,32.9298061 1285.64137,36.5124154 C1283.89909,40.0950246 1284.3551,44.3579099 1286.81575,47.4909258 C1287.45472,44.844738 1290.87481,42.8222213 1295.00218,42.8222213 C1299.1269,42.8222213 1302.54873,44.8445005 1303.18841,47.4904428 C1305.64921,44.3575628 1306.10532,40.094678 1304.36305,36.5120863 C1302.62077,32.9294946 1298.98595,30.6560969 1295.00218,30.6573249 Z M1294.10538,33.3662209 C1296.20281,32.8710854 1298.3045,34.1700031 1298.79964,36.2674348 C1299.29477,38.3648664 1297.99586,40.4665573 1295.89843,40.9616928 C1293.80099,41.4568282 1291.6993,40.1579105 1291.20417,38.0604789 C1290.70903,35.9630472 1292.00795,33.8613564 1294.10538,33.3662209 Z"
  }))));
};

exports["default"] = Account;